import React, { useEffect, memo, type ComponentType } from 'react';
import isNil from 'lodash/isNil';
import { Box, xcss } from '@atlaskit/primitives';
import { ConnectIframe } from '@atlassian/connect-module-core';
import DefaultConnectIFrameProvider from '@atlassian/jira-common-ecosystem/src/index.tsx';
import type { EcosystemModuleProps } from '@atlassian/jira-connect-utils/src/common/types.tsx';
import { getConnectHost } from '@atlassian/jira-connect-utils/src/common/utils/ecosystem-connect-host.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import TimeoutView from '../../common/ui/ecosystem-timeout-view/index.tsx';

const ErrorIndicator = ({ appName, appKey }: { appName: string; appKey: string }) => (
	<TimeoutView appName={appName} appKey={appKey} />
);

const ConnectModule = (props: EcosystemModuleProps) => {
	const {
		options,
		appKey,
		moduleKey,
		appName,
		key: keyProp,
		options: { url },
		location = 'connect-utils.ecosystem-module',
		onLoad,
		onLoadingComplete,
		onTimeout,
	} = props;

	const key = isNil(keyProp) ? `connect-iFrame-${appKey}-${moduleKey}` : keyProp;
	const connectIframeProvider = new DefaultConnectIFrameProvider({
		handleOnLoadingComplete: onLoadingComplete,
		handleOnTimeout: onTimeout,
	});

	useEffect(() => {
		if (onLoad) {
			onLoad(location);
		}
	}, [onLoad, location]);

	return (
		<Box xcss={paddingStyles}>
			<ConnectIframe
				key={key}
				appKey={appKey}
				moduleKey={moduleKey}
				url={url}
				connectHost={getConnectHost()}
				connectIframeProvider={connectIframeProvider}
				options={connectIframeProvider.convertConnectOptions(options)}
				width="100%"
				height="100%"
				// @ts-expect-error - TS2322 - Type '() => JSX.Element' is not assignable to type 'typeof PureComponent'.
				failedToLoadIndicator={() => <ErrorIndicator appKey={appKey} appName={appName} />}
				// @ts-expect-error - TS2322 - Type '() => JSX.Element' is not assignable to type 'new () => PureComponent<{ failedCallback: Function; }, {}, any>'.
				timeoutIndicator={() => <ErrorIndicator appKey={appKey} appName={appName} />}
			/>
			<ContextualAnalyticsData sourceName="connectEcosystemModule" sourceType={SCREEN}>
				<FireScreenAnalytics attributes={{ location }} />
			</ContextualAnalyticsData>
		</Box>
	);
};

export const EcosystemModule: ComponentType<EcosystemModuleProps> = memo(ConnectModule);

const paddingStyles = xcss({
	marginTop: 'space.300',
});
